import { render, staticRenderFns } from "./whatsapp-drawer.vue?vue&type=template&id=07be13cd&scoped=true"
import script from "./whatsapp-drawer.vue?vue&type=script&lang=js"
export * from "./whatsapp-drawer.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-drawer.vue?vue&type=style&index=0&id=07be13cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be13cd",
  null
  
)

export default component.exports